<template>
  <div id="app">
    <!-- 公共头部组件 -->
    <Header />
    
    <!-- 路由视图 -->
    <router-view />
    
    <!-- 公共底部组件 -->
    <Footer />
    
    <!-- 回到顶部和客服组件 -->
    <BackTop />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import BackTop from './components/BackTop.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    BackTop
  },
  mounted() {
    // 页面加载完成后的初始化操作
    this.initPage()
  },
  methods: {
    initPage() {
      // 可以在这里添加全局初始化逻辑
      console.log('禾苗官网初始化完成')
    }
  }
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  line-height: 1.6;
}

/* 链接样式 */
a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

a:hover {
  color: #007bff;
}

/* 动画效果 */
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 30px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -30px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.slideInDown {
  animation-name: slideInDown;
}

/* 响应式工具类 */
.pc {
  display: block;
}

.mobile {
  display: none;
}

@media (max-width: 767px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
}

/* Flex布局工具类 */
.flex {
  display: flex;
}

.flex-center {
  justify-content: center;
  align-items: center;
}

.flex-between {
  justify-content: space-between;
}

.flex-column {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

/* 间距工具类 */
.mt10 { margin-top: 10px; }
.mb100 { margin-bottom: 100px; }
</style>